export default "__VITE_ASSET__C1$Z3_1E__"